import { getMyPermissions } from "../api/modules/me";
import { setPermissionCodes } from "./permissionStore";

/** 独立于 permissionStore（无 request 链路），仅供 Layout / 用户页等在运行期刷新 */
export async function refreshPermissionsFromServer() {
  const codes = await getMyPermissions();
  setPermissionCodes(Array.isArray(codes) ? codes : []);
}
